//Only Modes (Home, Item)


var init = {view: 'HOME',main: null}

const modeReducer = (state= init,action) => {
	switch(action.type) {
		case "goToHome":
			let obj = {
				view: 'HOME',
				main: null
			}
			return obj;

		case "goToItem":
			let obj2 = {
				view: 'ITEM',
				main: action.main
			}
			return obj2;

		default:
			return state;

	}

}


export default modeReducer